// extracted by mini-css-extract-plugin
module.exports = {"LogoContainer":"LogoContainer_LogoContainer__2jWkG","Logo":"LogoContainer_Logo__a-hiq"};